import { Component } from '@angular/core';

@Component({
    selector: 'app-gascalc',
    templateUrl: './gascalc.component.html',
    styleUrl: './gascalc.component.scss',
    standalone: false
})
export class GascalcComponent {

}
